<template>
  <div class="page">
    <!-- <div class="container block-primary">
      <h1 class="header-title">นโยบายการรับเปลี่ยน / คืนสินค้าและคืนเงิน</h1>
      <h2 class="page-title">นโยบายการรับเปลี่ยน</h2>
      <ol>
        <li>บริษัทฯ ยินดีรับเปลี่ยน/คืนสินค้า ภายใน 7 วันทำการนับตั้งแต่ลูกค้าเซ็นรับสินค้านั้นแล้วหากเกินจากวันเวลาดังกล่าวแล้ว บริษัทฯ ขอสงวนสิทธิ์ในการไม่รับเปลี่ยน/คืนสินค้า</li>
        <li>ลูกค้าสามารถขอเปลี่ยน/คืนสินค้าโดยลูกค้าจะต้องทำการจัดส่งสินค้ากลับมายังบริษัทฯโดยที่สินค้าที่ลูกค้าต้องการเปลี่ยน/คืนจะต้องอยู่ในสภาพสมบูรณ์ ไม่ชำรุดเสียหายจากการใช้งาน สภาพสินค้าต้องไม่เกิดการเปลี่ยนแปลงใดๆ รวมถึงป้ายราคา ป้ายยี่ห้อสินค้า เอกสารคู่มือต่างๆยังคงอยู่ และบรรจุ ในหีบห่อบรรจุภัณฑ์ของสินค้านั้นๆ ในสภาพเดียวกันกับสภาพที่บริษัทฯ นำส่งต่อลูกค้าพร้อมแสดงหลักฐานในการทำรายการ หลักฐานภาพถ่าย ยืนยันว่าสินค้าเสียหายจริง ซึ่งลูกค้าสามารถเปลี่ยน/คืนสินค้าตามกรณีดังต่อไปนี้
          <ol>
            <li>จัดส่งสินค้าผิดรุ่นสี หรือขนาด ให้กับลูกค้า</li>
            <li>จัดส่งสินค้าที่มีลักษณะแตกต่าง หรือไม่มีส่วนคล้ายคลึงกับรูปภาพของสินค้าที่ได้แสดงไว้ในหน้ารายละเอียดสินค้า</li>
            <li>จัดส่งสินค้าที่มีสภาพชำรุด เสียหาย หรือไม่สามารถใช้งานได้ตั้งแต่ได้รับสินค้า ให้กับลูกค้า</li>
          </ol>
        </li>
        <li>บริษัทฯ ขอสงวนสิทธิ์ในการพิจารณาตรวจสอบสภาพสินค้าที่ลูกค้าส่งกลับคืนมาก่อนจัดส่งสินค้าชิ้นใหม่ให้แก่ลูกค้า</li>
        <li>ทางบริษัทขอสงวนสิทธิ์ในการไม่รับเปลี่ยนสินค้าคืนทุกกรณี เช่น ลูกค้าไม่พึงพอใจในตัวผลิตภัณฑ์สินค้า ลูกค้าต้องการเปลี่ยนสินค้าข้ามรุ่น หรือลูกค้าสั่งซื้อสินค้าผิดรุ่น</li>
        <li>บริษัทฯ ขอสงวนสิทธิ์ในการรับเปลี่ยนสินค้าภายใต้นโยบายและเงื่อนไขตามที่บริษัทฯ กำหนดเท่านั้น</li>
      </ol>
      <h2 class="page-title">นโยบายการคืนเงิน</h2>
      <p>บริษัทฯ ขอสงวนสิทธิ์ไม่รับคืนเงินในทุกกรณี</p>
      <div class="alert alert--error mb-20">
        <p><strong>หมายเหตุ**</strong></p>
        <ul>
          <li>ลูกค้ากรุณาตรวจสอบความถูกต้องของนโยบายและเงื่อนไขต่างๆก่อนการสั่งซื้อสินค้าทุกครั้งเนื่องจากการรับประกันของสินค้าแต่ละรายการอาจมีความแตกต่างกันดังนั้นลูกค้าจะต้องตรวจสอบนโยบายการรับประกันสินค้าที่ต้องการสั่งซื้อก่อนทำการซื้อสินค้า</li>
          <li>ในกรณีสินค้าเกิดการชำรุด เสียหาย หรือไม่สามารถเปิดใช้งานได้ตั้งแต่ได้รับสินค้า กรุณาแจ้งเจ้าหน้าที่โดยทันทีที่พบ ตามช่องทาง E-mail ตั้งแต่เวลา 10.00น.– 16.00น. ทุกวัน ยกเว้นวันเสาร์-อาทิตย์และวันหยุดนักขัตฤกษ์</li>
          <li>ระยะเวลาดำเนินการในขั้นตอนการตรวจสอบสินค้าจนเปลี่ยนหรือซ่อมสินค้าจะใช้ระเวลาประมาณ15 - 30วันทำการ</li>
        </ul>
      </div>
    </div> -->
  </div>
</template>

<script>

export default {
  name: 'terms'
}
</script>



// WEBPACK FOOTER //
// Terms.vue?3be458fe